export const environment = {
  production: false,
  keycloakConfig: {
    url: 'https://power4business.deddie.gr/auth',
    realm: 'master',
    clientId: 'LGH0OX35530'
  }
};